import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PanelSection from 'components/v2/PanelSection';

export default function ListItemSummary({ children, className }) {
  return (
    <PanelSection className={classNames(className)}>{children}</PanelSection>
  );
}

ListItemSummary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.arrayOf([PropTypes.string, PropTypes.object]),
  ]),
};
